<template>
<v-app v-show="app_mode!='uninitialized' && app_mode!='launch_link'">
	<v-app-bar app class="k-app-toolbar" height="80">
		<div class="k-logo"><a href="https://casenetwork.imsglobal.org/" target="case_registry"><img src="images/imsg_globe_case_network.svg"></a></div>
		<div class="k-portal-page-title">CASE Network GUID Translator <div style="display:inline-block; background-color:#E1BEE7; color:#4A148C; border-radius:5px; margin-left:15px; padding:5px 10px; font-size:.75em;">BETA</div></div>
		<v-spacer></v-spacer>
		<div v-show="app_mode!='login'" style="white-space:nowrap">
			<v-btn class="mr-2" v-if="show_admin_btn" fab small @click="go_to_admin"><v-icon>fas fa-users-cog</v-icon></v-btn>
			<v-tooltip bottom>
				<template v-slot:activator="{on}"><v-btn v-on="on" fab small @click="sign_out"><v-icon>fas fa-sign-out-alt</v-icon></v-btn></template>
				<span>SIGN OUT — Currently signed in as {{user_info.email}}</span>
			</v-tooltip>
		</div>
	</v-app-bar>

	<v-content>
		<LoginView ref="login_view" v-if="app_mode=='login'"/>
		<AdminView ref="admin_view" v-if="app_mode=='admin'"/>
		<ProjectsView ref="projects_view" v-if="app_mode=='projects'"/>
		<TableView ref="table_view" v-if="app_mode=='table'"/>
		<!-- TODO: friendlier error message here -->
		<div class="ma-8" v-if="app_mode=='error'">
			<div class="k-error-header mb-4">
				<v-tooltip bottom><template v-slot:activator="{on}"><v-btn v-on="on" @click="go_to_projects" class="mr-3" fab color="primary"><v-icon>fas fa-arrow-left</v-icon></v-btn></template>Back to projects list</v-tooltip>
				OOPS!
			</div>
			<div v-html="loading_error"></div>
		</div>
	</v-content>

	<v-footer class="k-footer" v-show="app_mode!='table'">
		<div>
			v0.2.2 ©&nbsp;{{ new Date().getFullYear() }}&nbsp;&nbsp;<a href="https://www.imsglobal.org/">IMS&nbsp;Global&nbsp;Learning&nbsp;Consortium.</a><br>
			All rights reserved.&nbsp;&nbsp;<a href="https://www.imsglobal.org/casenetwork/terms" target="_blank">Terms of Use</a>
		</div>
		<v-spacer></v-spacer>
		<div>
			<a href="http://www.imsglobal.org/"><img alt="IMS Logo" src="images/imsglc_white_tag.svg"></a>
		</div>
	</v-footer>
</v-app>
</template>

<script>
import LoginView from './components/LoginView'
import ProjectsView from './components/ProjectsView'
import TableView from './components/TableView'
import AdminView from './components/AdminView'
import { mapState, mapGetters } from 'vuex'

export default {
	name: 'App',
	components: { LoginView, ProjectsView, TableView, AdminView },
	data() { return {
		app_mode: 'uninitialized',
		loading_error: '',
	}},
	computed: {
		...mapState(['user_info', 'cfitems', 'dbrows', 'all_projects', 'admin_users']),
		// ...mapGetters(['links', 'has_links']),
		show_admin_btn() {
			// list of admin users comes in via the initialize ajax call
			return this.admin_users.findIndex(email => email == this.user_info.email) > -1
		},
	},
	created() {
		window.vapp = this
		U.loading_start()
	},
	mounted() {
		this.initialize_app()
	},
	methods: {
		initialize_app(payload) {
			this.$store.dispatch('initialize_cgrtool', payload).then((mode)=>{
				U.loading_stop()
				// don't set app_mode until we're fully initialized;
				// that way we retain the blank window behind the loading indicator until everything is set up
				if (mode == 'login') {
					this.app_mode = mode
				} else {
					// if user was in admin mode, restore
					if (U.local_storage_get('cgrtool-admin') == 'true' && this.show_admin_btn) {
						this.go_to_admin()
					} else {
						// else if a project was formerly loaded, reload it now
						let project_index = U.local_storage_get('cgrtool-loaded-project-' + this.user_info.user_id)
						if (!empty(project_index)) {
							this.load_project(project_index)
						} else {
							this.app_mode = mode
						}
					}
				}
			}).catch((error)=>{
				if (error.indexOf('not_authorized') > -1) {
					error = 'You are not currently authorized to use this tool. Please contact Bruce Umpstead (<a href="mailto:bumpstead@imsglobal.com">bumpstead@imsglobal.com</a>) to request access.'
				}
				this.$alert(error)
			})
		},

		go_to_admin() {
			// if user was already in admin tool, go to projects
			if (this.app_mode=='admin') {
				this.go_to_projects()
			} else {
				U.local_storage_set('cgrtool-admin', 'true')
				vapp.app_mode = 'admin'
			}
		},

		go_to_projects() {
			U.local_storage_clear('cgrtool-admin')
			U.local_storage_clear('cgrtool-loaded-project-' + this.user_info.user_id)
			vapp.app_mode = 'projects'
		},

		load_project(project_index) {
			U.local_storage_set('cgrtool-loaded-project-' + this.user_info.user_id, project_index)
			this.$store.commit('set', ['project_index', project_index])
			this.$store.commit('set', ['project', this.all_projects[project_index]])

			U.loading_start()

			// load data one file at a time; start with case data
			this.$store.dispatch('load_case_data').then(()=>{
				this.$store.dispatch('load_dbrows').then(()=>{
					this.$store.dispatch('load_simscores').then(()=>{
						this.$store.dispatch('load_status').then(()=>{
							// files loaded!
							this.$nextTick(()=>{
								this.process_simscores_after_loading()
								this.process_simscores_dynamic()
								this.app_mode = 'table'
								U.loading_stop()
							})

						}).catch(error => {
							this.loading_error = 'Error loading status file: ' + error
							this.app_mode = 'error'
							U.loading_stop()
						})
					}).catch(error => {
						this.loading_error = 'Error loading similarity scores: ' + error
						this.app_mode = 'error'
						U.loading_stop()
					})
				}).catch(error => {
					this.loading_error = 'Error loading db rows: ' + error
					this.app_mode = 'error'
					U.loading_stop()
				})
			}).catch(error => {
				this.loading_error = 'Error loading CASE json: ' + error
				this.app_mode = 'error'
				U.loading_stop()
			})
		},

		process_simscores_after_loading() {
			// check for duplicate top_simscores and try to correct if we can,
			// looking just at simscores for description and code, along with grade levels
			for (let j = 0; j < this.dbrows.length; ++j) {
				let dbrow = this.dbrows[j]
				if (dbrow.simscores.length == 0) {
					console.log('no simscores for dbrow ' + j)
					continue
				}
				// if (dbrow.sid == '920528') debugger

				// count total code_matches, where codescore_raw is 1
				let code_matches = 0
				if (dbrow.simscores[0].codescore_raw == 1) ++code_matches

				// look through simscores #2 and on...
				for (let i = 1; i < dbrow.simscores.length; ++i) {
					let new_simscore = dbrow.simscores[i]
					if (new_simscore.codescore_raw == 1) ++code_matches

					// if this new_simscore matches the current top simscore, try to correct
					if (new_simscore.descscore_raw == dbrow.top_simscore.descscore_raw) {
						// get references to new case item, current-top case item, and current top simscore
						let new_case_item = this.cfitems[new_simscore.case_guid]
						let ct_case_item = dbrow.selected_case_item
						let ct_simscore = dbrow.top_simscore

						if (empty(ct_case_item)) continue

						let multiple_tops = true

						// if one or the other has a code_match, use the one with the code_match
						if (ct_simscore.codescore_raw == 1 && new_simscore.codescore_raw != 1) {
							multiple_tops = false
							// console.log('resolved on basis of code_match (ct): ' + dbrow.sid)
						} else if (new_simscore.codescore_raw == 1 && ct_simscore.codescore_raw != 1) {
							multiple_tops = false
							this.$store.commit('set', [dbrow, 'selected_case_item', new_case_item])
							this.$store.commit('set', [dbrow, 'top_simscore', new_simscore])
							// console.log('resolved on basis of code_match (new): ' + dbrow.sid)

						// check codescores: if not equal, use the one with the higher codescore
						} else if (ct_simscore.codescore > new_simscore.codescore) {
							multiple_tops = false

						} else if (new_simscore.codescore > ct_simscore.codescore) {
							multiple_tops = false
							this.$store.commit('set', [dbrow, 'selected_case_item', new_case_item])
							this.$store.commit('set', [dbrow, 'top_simscore', new_simscore])
						}

						// if this dbrow goes with one grade...
						if (multiple_tops && !empty(dbrow.grade_low) && dbrow.grade_low == dbrow.grade_high) {
							let ct_grades = 0
							let new_grades = 0
							// if one CASE item goes with multiple grades and the other doesn't, resolve
							// NOTE: the similarity-computation algorithm filters out CASE items where the grade doesn't match the DB item's grade at all
							if (!empty(ct_case_item.educationLevel)) {
								ct_grades = ct_case_item.educationLevel.length
							}
							if (!empty(new_case_item.educationLevel)) {
								new_grades = new_case_item.educationLevel.length
							}

							if (ct_grades == 1 && new_grades > 1) {
								multiple_tops = false
								// console.log('resolved on basis of grade levels (ct): ' + dbrow.sid, dbrow)

							} else if (new_grades == 1 && ct_grades > 1) {
								multiple_tops = false
								this.$store.commit('set', [dbrow, 'selected_case_item', new_case_item])
								this.$store.commit('set', [dbrow, 'top_simscore', new_simscore])
								// console.log('resolved on basis of grade levels (new): ' + dbrow.sid, dbrow)
							}
						}

						// if multiple_tops is true and ct is a copy and new is *not* a copy, bubble new to the top
						// if (multiple_tops && !empty(new_case_item.is_copy_of) && empty(ct_case_item.is_copy_of)) {
						if (multiple_tops && !empty(ct_case_item.is_copy_of) && empty(new_case_item.is_copy_of)) {
							console.log('bubble non-copy to top ' + dbrow.sid)
							this.$store.commit('set', [dbrow, 'selected_case_item', new_case_item])
							this.$store.commit('set', [dbrow, 'top_simscore', new_simscore])
							// (but don't determine multiple_tops from this)
						}

						if (multiple_tops) {
							this.$store.commit('set', [dbrow, 'multiple_tops', true])
						}
					}
				}

				// now that we've gone through all the simscores, if there is a single code_match...
				if (code_matches == 1 && dbrow.multiple_tops == true) {
					// then the one with the code_match is the right top, even if multiple_tops got set to true above
					this.$store.commit('set', [dbrow, 'multiple_tops', false])
					if (dbrow.top_simscore.codescore_raw != 1) {
						console.log('ERROR: top_simscore.codescore_raw should be true for ' + dbrow.sid)
					}
				}
			}
		},

		process_simscores_dynamic() {
			// check for duplicate top_simscores and try to correct if we can
			let mtct = 0
			for (let j = 0; j < this.dbrows.length; ++j) {
				let dbrow = this.dbrows[j]
				if (dbrow.multiple_tops == true) {
					// 1. try to use CASE tree structure to resolve conflicts
					// look at next item in dbrows. If we're confident about which CASE item the next item goes with,
					// and the next item's parent (from the CASE tree) is this dbrow,
					// then assume that this dbrow is that next item's parent
					let next_dbrow = this.dbrows[j+1]
					if (!empty(next_dbrow)) {
						// if (dbrow.sid == 920048) debugger

						// if it doesn't have multiple_tops and has a top_sim that's really high
						// if (next_dbrow.multiple_tops != true && next_dbrow.top_simscore.descscore_raw > 0.99) {
						if (next_dbrow.multiple_tops != true && next_dbrow.status == 'matched') {
							// look at the selected_case_item for this guy
							let next_case_item = next_dbrow.selected_case_item
							if (empty(next_case_item)) continue

							// then look through next_case_item's nodes in the CF tree
							for (let nci_tree_node of next_case_item.tree_nodes) {
								// get the parent GUID for this node
								let nci_parent_guid = nci_tree_node.parent_node.cfitem.identifier

								// if this parent GUID is one of the the available options, assign to it
								for (let simscore of dbrow.simscores) {
									// if it's one of the top simscores...
									if (simscore.descscore_raw == dbrow.top_simscore.descscore_raw) {
										if (simscore.case_guid == nci_parent_guid) {
											// FOUND IT!!!
											// console.log('Found match based on tree location!! ' + dbrow.sid)
											this.$store.commit('set', [dbrow, 'selected_case_item', this.cfitems[simscore.case_guid]])
											this.$store.commit('set', [dbrow, 'top_simscore', simscore])
											this.$store.commit('set', [dbrow, 'multiple_tops', false])
										}
									}
								}
							}
						}
					}

					// 2. if all but one of the items on top are copies of the other item, use the original
					let new_top_simscore = ''
					// if the current top_simscore isn't a copy, start with it in new_top_simscore
					if (empty(dbrow.selected_case_item.is_copy_of)) {
						new_top_simscore = dbrow.top_simscore
					}

					// if (dbrow.sid == '921150') debugger
					for (let simscore of dbrow.simscores) {
						if (simscore == dbrow.top_simscore) continue

						if (simscore.descscore_raw == dbrow.top_simscore.descscore_raw) {
							let case_item = this.cfitems[simscore.case_guid]
							// if new_top_simscore hasn't been set and this simscore's case item *isn't a copy of something else*,...
							if (empty(new_top_simscore) && empty(case_item.is_copy_of)) {
								// then save this simscore as new_top_simscore
								new_top_simscore = simscore

							// else if original *has* been set and this item *isn't a copy of the original*...
							} else if (!empty(new_top_simscore) && case_item.is_copy_of != new_top_simscore.case_guid) {
								// then the jig's up -- all other top items aren't copies of new_top_simscore, so stop looking
								// UNLESS new_top_simscore is a code_match
								if (new_top_simscore.codescore_raw != 1) {
									new_top_simscore = ''
									break
								}
							}
						}
					}
					// if we got through the above with new_top_simscore set, set it!
					if (!empty(new_top_simscore)) {
						// console.log('Found match based on CASE exact matches!! ' + dbrow.sid)
						this.$store.commit('set', [dbrow, 'selected_case_item', this.cfitems[new_top_simscore.case_guid]])
						this.$store.commit('set', [dbrow, 'top_simscore', new_top_simscore])
						this.$store.commit('set', [dbrow, 'multiple_tops', false])
					}

					if (dbrow.multiple_tops == true) {
						// console.log('multiple tops: ' + dbrow.sid)
						++mtct
					}
				}
			}

			console.log('multiple tops found: ' + mtct)
		},

		sign_out() {
			this.$store.dispatch('sign_out')
		},
	}
}
</script>

<style lang="scss">
body {
	font-size:18px;
}

.v-application {
	font-family: $sans-serif-font;
}

.theme--dark.v-application {
	// background:transparent;
}

.v-btn {
	text-transform: none;
	font-size:16px;
}

.k-app-toolbar {
	background-color:$ims-blue!important;
}

.k-logo {
	position:absolute;
	img {
		height:64px;
	}
}

.k-portal-page-title {
	font-size:28px;
	font-weight:bold;
	color:#fff;
	margin-left:100px;
	// margin-right:180px;
	text-align:center;
	width:100%;
}

.k-footer {
	position:fixed;
	bottom:0;
	width:100vw;
	height:60px;
	padding:0 30px;
	background-color:$ims-blue!important;
	color:#fff!important;
	font-size:14px;
	a {
		color:#ccc!important;
		text-decoration:none;
	}
	img {
		height:45px;
	}
}

.k-error-header {
	color:$ims-blue;
	font-size:36px;
	font-weight:bold;
}
</style>
